import confirm from '#utilities/js/ea/confirm.js'
import * as menu from '#utilities/js/lightboxes/menus/menu.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'

const { document } = globalThis

const selectors = [
  'form input[type="image"]',
  'form input[type="submit"]',
  'form button[type="submit"]',
  'form button:not([type])',
  'button[type="submit"][form="mainform"]',
  '.ea_utilities__submit_out_form'
]

const selector = `${selectors}`

const events = new WeakSet()
const resolvers = new WeakMap()

let clicked

const onTapUp = object(tapUp, {
  capture,
  passive,
  task: (document, event) => {
    const { target } = event
    const button = closest('button', target)
    
    clicked = button?.matches?.(selector) ? button : undefined
    
    if (button) {
      resolvers.set(button, resolvable())
    }
  }
})

export const handled = async (
  submitter
) => {
  return resolvers.get(submitter)?.at(0)
}

export const resolve = (
  submitter
) => {
  if (resolvers.has(submitter)) {
    const [, { resolve }] = resolvers.get(submitter)
    
    resolvers.delete(submitter)
    resolve()
  }
}

export const shim = event => {
  if (events.has(event)) {
    return event
  }
  
  const { submitter } = event
  
  if (!submitter) {
    const { activeElement } = document
    
    event.submitter = activeElement?.matches(selector) ? activeElement : clicked
  }
  
  events.add(event)
  clicked = undefined
  
  return event
}

export const task = async function (
  button,
  event
) {
  const { dataset } = button
  const { confirm: message } = dataset
  
  if (message) {
    const { title, text = '' } = JSON.parse(message)
    const openers = [button]
    const list = menu.list(button)
    let result
    
    preventDefault(event)
    stopImmediatePropagation(event)
    
    if (list) {
      openers.push(menu.opener(list))
    }
    
    menu.stash()
    result = await confirm(title, text, openers)
    
    if (result) {
      menu.unstash()
      this.forget(button)
      button.click()
      this.listen(button)
      
      if (list) {
        menu.close()
      }
    }
  }
}

onTapUp.listen(document)
